import { motion } from "framer-motion";
import Header from "../components/layout/Header";
import StatsCard from "../components/ui/StatsCard";
import BotCard from "../components/ui/BotCard";
import LoadingSkeleton from "../components/ui/LoadingSkeleton";
import { useApi } from "../hooks/useApi";

export default function Dashboard({ user, setActive }) {
  const { data, loading } = useApi("/api/miniapp/bootstrap", { profile: {}, bots: [], stats: {} });
  return (
    <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}>
      <Header user={user} />
      <section className="glass mt-4 rounded-app p-4">
        <p className="text-sm text-tg-hint">Current plan</p>
        <div className="mt-2 flex items-center justify-between"><strong className="text-2xl uppercase">{data.profile?.plan || "free"}</strong><button onClick={() => setActive("plans")} className="tap rounded-app bg-violet-600 px-4 py-2">Upgrade</button></div>
      </section>
      <section className="mt-4 grid grid-cols-3 gap-3">
        <StatsCard label="My Bots" value={data.bots?.length || 0} />
        <StatsCard label="Refs" value={data.profile?.referral_count || 0} />
        <StatsCard label="Earned" value={`₹${data.profile?.referral_earnings || 0}`} />
      </section>
      <div className="mt-6 flex items-center justify-between"><h2 className="text-lg font-black">Active Bots</h2><button onClick={() => setActive("create")} className="text-sm text-violet-300">Create</button></div>
      <div className="mt-3 grid gap-3">{loading ? <LoadingSkeleton /> : (data.bots || []).slice(0, 3).map((bot) => <BotCard key={bot._id} bot={bot} />)}</div>
      <section className="glass mt-6 rounded-app p-4"><h2 className="font-black">Platform</h2><p className="mt-2 text-sm text-tg-hint">Users {data.stats?.totalUsers || 0} · Bots {data.stats?.activeBots || 0}</p></section>
    </motion.div>
  );
}
